<script>
export var FormInput = {
    make: function(data) {
        var input = {};
        data = JSON.parse(JSON.stringify(data));
        input.key = data.key;
        input.label = data.label;
        input.attrs = {
            ...{
                disabled: false,
                required: false,
                pattern: false,
                maxlength: false,
                placeholder: ''
            },
            ...data.attrs
        };
        if (input.attrs.type == 'checkbox') {
            input.attrs['true-value'] = (typeof input.attrs['true-value'] == 'undefined') ? 'true' : input.attrs['true-value'];
            input.attrs['false-value'] = (typeof input.attrs['false-value'] == 'undefined') ? 'false' : input.attrs['false-value'];
        }
        input.options = (typeof data.options == 'undefined') ? [] : data.options;
        input.classesCss = ['form-group', `form-group-${data.key}`].concat((typeof data.classesCss == 'undefined') ? [] : data.classesCss);
        input.helperText = (typeof data.helperText == 'undefined') ? [] : data.helperText;
        input.visible = (typeof data.visible == 'undefined') ? true : data.visible;
        input.errorMessages = [];
        return input;
    }
};

export default {
    name: 'FormInputView',
    props: {
        input: Object,
        value: [Object, String, Boolean, Number]
    },
    data: function() {
        var data = {
            attrId: `form-input-${this.newId()}`,
            checkboxValue: this.value,
            optionIds: []
        };
        if (this.input.attrs.type == 'radio') {
            this.input.options.forEach(() => {
                data.optionIds.push(`form-input-${this.newId()}`);
            });
        }
        return data;
    },
    methods: {
        newId: function() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        checkboxChecked: function() {
            this.$emit('input', this.checkboxValue);
        }
    },
    watch: {
        value: function(newValue) {
            if (this.input.attrs.type == 'checkbox') {
                this.checkboxValue = newValue;
            }
        }
    },
    computed: {
        classesCss: function() {
            var classesCss = {};
            this.input.classesCss.forEach((k) => {
                classesCss[k] = true;
            });
            return classesCss;
        }
    }
}
</script>

<template src="./FormInput.html"></template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
